// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AudioPlayerTitle__container-f7c551 {
  cursor: pointer;
  display: flex;
  overflow: hidden;
}

.AudioPlayerTitle__title-b54f05 {
  color: var(--base-110);
  font: var(--font-body-2);
  letter-spacing: var(--font-spacing-body-2);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.AudioPlayerTitle__description-b6e349 {
  flex-shrink: 0;
  color: var(--base-80);
  font: var(--font-body-5);
  letter-spacing: var(--font-spacing-body-5);
  margin-inline-start: 4px;
}`, "",{"version":3,"sources":["webpack://./../../packages/ui-kit/src/Media/AudioPlayer/AudioPlayerUI/AudioPlayerTitle/AudioPlayerTitle.styles.m.css"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,aAAA;EACA,gBAAA;AACF;;AAEA;EACE,sBAAA;EACA,wBAAA;EACA,0CAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AACF;;AAEA;EACE,cAAA;EACA,qBAAA;EACA,wBAAA;EACA,0CAAA;EACA,wBAAA;AACF","sourcesContent":[".container {\n  cursor: pointer;\n  display: flex;\n  overflow: hidden;\n}\n\n.title {\n  color: var(--base-110);\n  font: var(--font-body-2);\n  letter-spacing: var(--font-spacing-body-2);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.description {\n  flex-shrink: 0;\n  color: var(--base-80);\n  font: var(--font-body-5);\n  letter-spacing: var(--font-spacing-body-5);\n  margin-inline-start: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `AudioPlayerTitle__container-f7c551`,
	"title": `AudioPlayerTitle__title-b54f05`,
	"description": `AudioPlayerTitle__description-b6e349`
};
module.exports = ___CSS_LOADER_EXPORT___;
